











































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import OriginatorRestrictionsFilter from "@/components/SMS/Restrictions/OriginatorRestrictionsFilter.vue";
import {ScrollButton} from "wings-ui-components";
import { RestrictionItem } from '@/store/sms/restrictions/types';

@Component({components:{OriginatorRestrictionsFilter, ScrollButton}})
export default class OriginatorRestrictions extends BaseItemsPage<RestrictionItem>{
  @Getter("restrictions") restrictionsResponse: any;
  @Getter("restrictionsList") restrictionsList: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'service_provider',
    'restriction',
  ];

  getData(): any {
    return this.restrictionsResponse;
  }

}
